
































































































import api from '@/services/api';
import { Component, Vue, Prop } from 'vue-property-decorator';
import UserNotification from '@/classes/UserNotification';
import WYSIWYG from '@/components/WYSIWYG.vue';

@Component({
    components: {
        WYSIWYG
    }
})
export default class UserNotificationForm extends Vue {
    public form: UserNotification = new UserNotification();
    @Prop({default: false}) public edit?: boolean;
    @Prop({default: false}) public view?: boolean;
    @Prop() public id!: number;

    public get datesValid(): boolean | null {
        if (this.form.publishDateTime === null || this.form.expirationDateTime === null || this.view) {
            return null;
        } else {
            return this.form.publishDateTime.getTime() < this.form.expirationDateTime.getTime();
        }
    }

    public get invalidFeedbackPublish(): string {
        return 'Publish Date must be before Expiration Date';
    }

    public get invalidFeedbackExpiration(): string {
        return 'Expiration Date must be after Publish Date';
    }

    public get submissionValid(): string[] {
        const issues: string [] = [];
        if (this.datesValid === false) {
            issues.push('Please fix date issues.');
        }
        if (this.form.notice === undefined || this.form.notice === null || this.form.notice.length < 8) {
            issues.push('Please enter notice information.');
        }
        return issues;
    }

    public mounted() {
        if (this.id) {
            this.updateForm();
        }
    }

    public updateForm() {
        if (this.id !== undefined && !isNaN(this.id)) {
            this.$store.dispatch('notifications/loadUserNotifications', true)
            .then(() => {
                const foundForm: UserNotification | null = this.$store.getters['notifications/getUserNotificationById'](this.id);
                if ( foundForm !== null) {
                    this.form = foundForm;
                } else {
                    alert('User Notification not found.');
                    this.$router.push('/administration/usernotifications');
                }
            });
        }
    }

    public submit(): void {
        if (this.submissionValid.length > 0) {
            alert('Please correct the following: \n\n' + this.submissionValid.reduce((a: string, e: string) => a + '\n' + e ));
        } else {
            const dispatchString: string = this.edit ? 'notifications/editUserNotification' : 'notifications/addUserNotification';
            this.$store.dispatch(dispatchString, this.form)
            .catch(() => {
                alert('There was an issue performing this action.');
                this.$router.push('/administration/usernotifications');
            });
        }
    }

    public deleteNotification(): void {
        this.$store.dispatch('notifications/deleteUserNotification', this.form)
        .catch(() => {
            alert('There was an issue performing this action.');
            this.$router.push('/administration/usernotifications');
        });
    }

    public get cardTitle(): string {
        if (this.edit) {
            return 'Edit User Notification';
        } else if (this.view) {
            return 'View User Notification';
        } else {
            return 'New User Notification';
        }
    }

    public getUserProfileName(id: number) {
        const user = this.$store.getters.getUserProfileById(id);
        if (user) {
        return user.getFullName();
        } else {
        return '';
        }
    }
}
